<template>
    <div>
        <v-dialog max-width="1100px" persistent v-model="showUserModal" @close="close">
            <v-card>
                <v-card-title class="mb-0, pb-0">
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text class="mx-0, py-0, px-0">
                    <!--TABS-->
                    <v-tabs
                        v-model="active_tab"
                        color="blue-grey darken-2 white--text"
                        dark
                        slider-color="blue-grey darken-1"
                        grow
                    >
                        <!--Tab General-->
                        <v-tab :key="'tab_general'" ripple >Geral</v-tab>
                        <v-tab-item :key="'tab_general'" >
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md8 px-2>
                                        <v-text-field v-model="formUser.name"
                                            :counter="$v.formUser.name.$params.maxLength.max"
                                            :error-messages="nameErrors"
                                            @blur="$v.formUser.name.$touch()"
                                            :readonly="userShow"
                                            label="Nome*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formUser.bi"
                                            :error-messages="biErrors"
                                            :loading="biAvailable===search.searching"
                                            :success="biAvailable===search.available"
                                            :error="biAvailable===search.notAvailable"
                                            :append-icon="biAvailable===search.available ? 'done' : biAvailable===search.notAvailable ? 'clear' : ''"
                                            :class="biAvailable===search.available ? 'green--text' : biAvailable===search.notAvailable ? 'red--text' : ''"
                                            @blur="checkDataInUse(2, formUser.bi)"
                                            @input="biAvailable = 0"
                                            :readonly="userShow"
                                            label="Num. Documento*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 px-2>
                                        <v-select v-model="formUser.groups_id"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="groupErrors"
                                            @blur="$v.formUser.groups_id.$touch()"
                                            :disabled="userShow || loggedUser.id === selectedUser.id"
                                            :items="groups" label="Grupo*"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formUser.address"
                                            :counter="$v.formUser.address.$params.maxLength.max"
                                            :error-messages="addressErrors"
                                            @blur="$v.formUser.address.$touch()"
                                            :readonly="userShow"
                                            label="Morada"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formUser.phone"
                                            :counter="$v.formUser.phone.$params.maxLength.max"
                                            :error-messages="phoneErrors"
                                            @blur="$v.formUser.phone.$touch()"
                                            :readonly="userShow"
                                            max="7"
                                            prefix="(+238)"
                                            mask="### ## ##"
                                            label="Movel"></v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12>
                                        <v-divider v-if="formUser.access" class="mt-4"></v-divider>
                                    </v-flex>

                                    <v-flex xs12 sm12 md2 px-2>
                                        <v-checkbox
                                            v-model="formUser.access"
                                            :disabled="userShow || loggedUser.id === selectedUser.id"
                                            @change="clearAccessInfos"
                                            label="Acesso"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 sm6 md5 px-2>
                                        <v-text-field
                                            v-model="formUser.email"
                                            class="mr-2"
                                            :error-messages="emailErrors"
                                            :loading="emailAvailable===search.searching"
                                            :success="emailAvailable===search.available"
                                            :error="emailAvailable===search.notAvailable"
                                            :append-icon="emailErrors.length > 0 ? 'clear' : emailAvailable===search.available ? 'done' : ''"
                                            :class="emailAvailable===search.available ? 'purplue--text' : emailAvailable===search.notAvailable ? 'red--text' : ''"
                                            @blur="checkDataInUse(1, formUser.email)"
                                            @input="emailAvailable = 0"
                                            :readonly="userShow"
                                            prepend-icon="email"
                                            label="Email*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md5 px-2>
                                        <v-text-field v-if="formUser.access && canEditSensitiveInfo"
                                            v-model="formUser.password"
                                            class="ml-2"
                                            :counter="$v.formUser.password.$params.maxLength.max"
                                            :readonly="userShow"
                                            :error-messages="passwordErrors"
                                            @blur="$v.formUser.password.$touch()"
                                            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            @click:append="showPassword = !showPassword"
                                            prepend-icon="lock"
                                            label="Senha*"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>

                        <!--Tab Foto-->
                        <v-tab :key="'tab_photo'" ripple >Foto</v-tab>
                        <v-tab-item :key="'tab_photo'" >
                            <v-container>
                                <v-layout row>
                                    <v-flex grow></v-flex>
                                    <v-flex xs12 sm6 md6 lg4>
                                        <image-uploader v-if="showUserModal"
                                            :image_path="selectedUser.image_path"
                                            @onImageUploader="imageUploaderCallback($event)"
                                        ></image-uploader>
                                    </v-flex>
                                    <v-flex grow></v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <template v-if="!loading_modal">
                        <v-btn depressed @click="cancelChanges">Cancelar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!userShow && active_tab === 0"
                               :disabled="checkNextButton()"
                               color="primary" @click="active_tab = 1">Seguinte</v-btn>

                        <v-btn v-if="!userShow && active_tab === 1" color="primary" @click="active_tab = 0">Anterior</v-btn>
                        <v-btn v-if="!userShow && active_tab !== 0"
                               :disabled="checkNextButton()" color="primary" @click="save">Guardar</v-btn>
                    </template>
                    <template v-else>
                        <v-spacer></v-spacer>
                        <v-progress-circular indeterminate color="primary" m-2 ></v-progress-circular>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Vue from 'vue';
    import _ from 'lodash';
    import {eventBus} from "../../main";
    import {mapGetters} from 'vuex';
    import {maxLength, minLength, numeric, email, required, requiredIf} from 'vuelidate/lib/validators'
    import ImageUploader from'../image/ImageUploader';
import { watch } from 'vue';

    export default {
        name: 'user_form_modal',

        created(){
            let vm = this;
            // this.onCompanyAddOrEdited(vm);
            this.onUserFormModalOpened(vm);
        },

        beforeDestroy () {
            eventBus.$off('onUserFormOpened');
        },

        watch:{
            showUserModal(){
                if(this.showUserModal){
                    this.onModalOpen();
                }
            },
        },

        data () {
            return {
                showPassword: false,
                active_tab: 0,
                loading_modal: false,
                company_modal_loading: false, // loading that shows while all required atributes for form company modal is loaded in the background
                companies: [], //list of companeis used in auto complete field (this is querried at the moment)
                selectedFile: null,
                canEditSensitiveInfo: true,

                //company form modal needed attributes
                company_types: [],
                company_categories: [],

                originalUser: {
                    name: '',
                    companies_id: '',
                    groups_id: '',
                    bi: '',
                    address: '',
                    phone: '',
                    image: '',
                    email: '',
                    password: '',
                },
                userImage: null,

                //AutoComplete
                isLoading: false,

                search:{
                    searching:1,
                    notAvailable:2,
                    available:3,
                },

                emailAvailable: 0,
                biAvailable: 0,


            }
        },

        validations: {
            formUser: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(30),
                },
                groups_id: {
                    numeric,
                    required,
                },
                bi: {
                    numeric,
                    // required,
                },
                email: {
                    email,
                    required,
                },
                password: {
                    minLength: minLength(6),
                    maxLength: maxLength(40),
                    required: requiredIf(function (nestedModel) {
                        return this.formUser.access && !this.formUser.id;
                    })
                },
                address: {
                    maxLength: maxLength(80)
                },
                phone: {
                    maxLength: maxLength(15)
                },
            }

        },

        components: {
            ImageUploader,
        },

        methods: {
            onModalOpen(){
                if(this.isInEditMode()){
                    this.checkDataInUse(1, this.$v.formUser.email);
                    this.checkDataInUse(2, this.$v.formUser.bi);
                }
            },

            imageUploaderCallback(payload){
                this.userImage = payload;
            },

            checkTab1NextButton(){

            },

            checkNextButton(){

                let var1 = this.$v.formUser.name.$invalid || this.$v.formUser.groups_id.$invalid 
                    || this.emailAvailable!==this.search.available || this.$v.formUser.email.$invalid 
                    || this.$v.formUser.bi.$invalid || this.biAvailable!==this.search.available;
                

                if(this.formUser.access){
                    return var1 
                        || this.$v.formUser.email.$invalid || this.$v.formUser.password.$invalid
                        || (this.formUser.id ? false : this.emailAvailable!==this.search.available );
                }

                return var1;

            },

            cancelChanges(){
                this.close();
            },

            addUser(){
                try{
                    this.loading_modal = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.post('user', {
                        name: this.formUser.name,
                        groups_id: this.formUser.groups_id,
                        bi: this.formUser.bi,
                        access: this.formUser.access ? this.formUser.access : 0,
                        file: this.userImage,
                        email_contact: this.formUser.email_contact,
                        address: this.formUser.address,
                        phone: this.formUser.phone,
                        email: this.formUser.email,
                        password: this.formUser.access ? this.formUser.password : '',
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        let user = response.data.response;
                        // this.consoleLog('Emitting adding user event, USER: '+user.name);
                        eventBus.$emit('onFormUserDone', user, 0);

                        this.showSnackBar('Utilizador adicionado com sucesso', 'success');
                        this.close();
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao adicionar utilizador', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao adicionar utilizador!', 'error');
                    this.loading_modal = false;
                }
            },

            updateUser(){
                try{
                    if(this.selectedUser === null) {
                        this.showSnackBar('Ocorreu um erro ao atualizar utilizador', 'error');
                        return;
                    }

                    this.loading_modal = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('user/'+this.selectedUser.id, {
                        name: this.formUser.name,
                        groups_id: this.formUser.groups_id,
                        bi: this.formUser.bi,
                        file: this.userImage,
                        old_image_url: this.selectedUser.image,
                        email_contact: this.formUser.email_contact,
                        address: this.formUser.address,
                        phone: this.formUser.phone,
                        access: this.formUser.access,
                        email: this.formUser.email,
                        password: this.formUser.access && this.formUser.password ? this.formUser.password : '',

                    }).then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        let updatedUser = response.data.response;
                        eventBus.$emit('onFormUserDone', updatedUser, 1);
                        this.close();
                        this.showSnackBar('Utilizador atualizado com sucesso', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao atualizar utilizador', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao atualizar utilizador!', 'error');
                    this.loading_modal = false;
                }
            },

            resetForm(){
                this.formUser.name = '';
                this.formUser.bi = '';
                this.formUser.group = '';
                this.formUser.email_contact = '',
                this.formUser.address = '',
                this.formUser.phone = '',
                this.formUser.access = '';
                this.formUser.email = '';
                this.formUser.password = '';
            },

            close () {
                this.showUserModal = false;
                this.active_tab = 0;
                this.$v.$reset();
                this.resetForm();
                this.emailAvailable = 0;
                this.biAvailable = 0;
                this.canEditSensitiveInfo = true;

                setTimeout(() => {
                    this.loading = false;
                    this.userShow = false;
                    this.selectedUser = null;
                }, 300);
            },

            save () {
                if (this.selectedUser.id) {
                    // this.consoleLog('editing');
                    this.updateUser();
                } else {
                    // this.consoleLog('adding');
                    this.addUser();
                    // this.consoleLog(JSON.stringify(this.selectedUser, null, 4));
                }
            },

            checkDataInUse(op, data){
                if(op === 1){
                    this.$v.formUser.email.$touch();
                    if(!data) {
                        this.emailAvailable = 0;
                        return;
                    }
                    this.emailAvailable = this.search.searching;
                }else if(op === 2){
                    this.$v.formUser.bi.$touch();
                    if(!data) {
                        this.biAvailable = 0;
                        return;
                    }
                    this.biAvailable = this.search.searching;
                }


                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get('user/data_in_use', {
                    params: {op: op, data: data, user_id: this.selectedUser.id}
                })
                    .then(response=>{
                        this.consoleLog('data_in_use', response);
                        if(op ===1 ){
                            this.emailAvailable = response.data.success ? this.search.available : this.search.notAvailable;
                            // this.emailAvailable = 0;
                        }else if(op === 2){
                            this.biAvailable = response.data.success ? this.search.available : this.search.notAvailable;
                            // this.biAvailable = 0;
                        }
                    }).catch(error=>{
                    this.consoleLog(error);
                })
            },

            onUserFormModalOpened(vm){
                eventBus.$on('onUserFormOpened', function(editing, canEditSensitiveInfo){
                    vm.consoleLog('userFormModalOpened: '+canEditSensitiveInfo);
                    vm.canEditSensitiveInfo = canEditSensitiveInfo;
                });
            },

            clearAccessInfos(){
                if(!this.selectedUser.id){
                    // this.formUser.email = '';
                    // this.$v.formUser.email.$reset();
                    // this.emailAvailable = 0;

                    this.formUser.password = '';
                    this.$v.formUser.password.$reset();
                }
            },

            isInEditMode(){
                return this.selectedUser.id;
            },


        },


        computed: {
            ...mapGetters([
                'getToken',
                'loggedUser',
            ]),
            showUserModal: {
                get(){
                    return this.$store.getters.getShowUserModal;
                },
                set(value){
                    this.$store.dispatch('setShowUserModal', value);
                }
            },
            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },
            formUser: {
                get(){
                    return this.$store.getters.getFormUser;
                },
                set(value){
                    this.$store.dispatch('setFormUser', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            userShow: {
                get(){
                    return this.$store.getters.getUserShow;
                },
                set(value){
                    this.$store.dispatch('setUserShow', value);
                }
            },
            groups: {
                get(){
                    return this.$store.getters.getGGroups;
                },
                set(value){
                    this.$store.dispatch('setGGroups', value);
                }
            },
            g_active_states() {
                return this.$store.getters.getGActiveStates;
            },

            formTitle () {
                return this.userShow ? 'Funcionário' : (this.isInEditMode() ? 'Editar Funcionário' : 'Novo Funcionário');
            },
            nameErrors () {
                const errors = [];
                if (!this.$v.formUser.name.$dirty) return errors;
                !this.$v.formUser.name.minLength && errors.push('Mínimo de 2 caracteres');
                !this.$v.formUser.name.maxLength && errors.push('Máximo de 30 caracteres');
                !this.$v.formUser.name.required && errors.push('Digite um nome');
                return errors
            },
            groupErrors () {
                const errors = [];
                if (!this.$v.formUser.groups_id.$dirty) return errors;
                !this.$v.formUser.groups_id.numeric && errors.push('Tem de ser um número');
                !this.$v.formUser.groups_id.required && errors.push('Escolha um Grupo');
                return errors
            },
            biErrors () {
                const errors = [];
                if (!this.$v.formUser.bi.$dirty) return errors;
                this.consoleLog('this.biAvailable: ', this.biAvailable)
                this.$v.formUser.bi.required && errors.push('Obrigátorio');
                this.biAvailable === this.search.notAvailable && errors.push('Este Num. documento se encontra em uso');
                // !this.$v.formUser.bi.numeric && errors.push('Tem de ser um número');
                // !this.$v.formUser.bi.required && errors.push('Introduza número de BI');
                return errors
            },
            phoneErrors(){
                const errors = [];
                if (!this.$v.formUser.phone.$dirty) return errors;
                !this.$v.formUser.phone.maxLength && errors.push('Máximo de 15 caracteres');
                return errors;
            },
            addressErrors(){
                const errors = [];
                if (!this.$v.formUser.address.$dirty) return errors;
                !this.$v.formUser.address.maxLength && errors.push('Máximo de 80 caracteres');
                return errors;
            },
            emailErrors () {
                const errors = [];
                if (!this.$v.formUser.email.$dirty) return errors;
                !this.$v.formUser.email.email && errors.push('Introduza um email válido');
                !this.$v.formUser.email.required && this.formUser.access && errors.push('Introduza um email');
                this.emailAvailable === this.search.notAvailable && errors.push('Este e-mail se encontra em uso');
                return errors
            },
            passwordErrors(){
                const errors = [];
                if (!this.$v.formUser.password.$dirty) return errors;
                !this.$v.formUser.password.minLength && errors.push('Mínimo de 6 caracteres');
                !this.$v.formUser.password.required && errors.push('Introduza uma senha');
                return errors
            },

        },
    }
</script>

<style scoped>

</style>